import { Check, type LucideIcon } from "lucide-react";
import type { OrganizationType } from "@bookdental/schemas";

type Option = {
  value: OrganizationType;
  title: string;
  description: string;
  icon: LucideIcon;
};

type Props = {
  options: Option[];
  selected: OrganizationType[];
  onToggle: (value: OrganizationType) => void;
  disabled?: boolean;
};

/** Grade de cards selecionáveis pra área de atuação — usada no onboarding, no perfil e em Configurações. */
export function OrganizationTypeGrid({ options, selected, onToggle, disabled }: Props) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      {options.map((opt) => {
        const Icon = opt.icon;
        const active = selected.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => onToggle(opt.value)}
            className={`relative flex flex-col gap-2 rounded-xl border p-4 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              active
                ? "border-brand-300 bg-brand-50 dark:border-primary/40 dark:bg-primary/10"
                : "border-zinc-200 bg-white hover:bg-zinc-50 dark:border-border dark:bg-card dark:hover:bg-muted"
            }`}
          >
            {active && (
              <span className="absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-brand-600 text-white dark:bg-primary">
                <Check className="h-3 w-3" />
              </span>
            )}
            <span
              className="flex h-12 w-12 items-center justify-center rounded-lg"
              style={{ backgroundColor: "#2457ff1a", color: "#2457ff" }}
            >
              <Icon className="h-6 w-6" />
            </span>
            <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">
              {opt.title}
            </p>
            <p className="text-[11.5px] leading-relaxed text-zinc-500 dark:text-muted-foreground">
              {opt.description}
            </p>
          </button>
        );
      })}
    </div>
  );
}
